import { render, staticRenderFns } from "./RomaActivityPieForm.vue?vue&type=template&id=12147b63&scoped=true"
import script from "./RomaActivityPieForm.vue?vue&type=script&lang=ts"
export * from "./RomaActivityPieForm.vue?vue&type=script&lang=ts"
import style0 from "./RomaActivityPieForm.vue?vue&type=style&index=0&id=12147b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12147b63",
  null
  
)

export default component.exports